import React, { useState, useEffect } from "react";
import PopularCollection from "../../../components/_home/PopularCollection/PopularCollection";
import { popular } from "../../../mock/popular";
import Slider from "react-slick";
import styles from "./Popular.module.scss";

const Popular = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    rows: 2,
    responsive: [
      {
        breakpoint: 1580,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  const [list, setList] = useState(null);
  const [num, setNum] = useState(4);

  useEffect(() => {
    if (popular) {
      if (popular.length > "4") {
        const slicedArray = popular.slice(0, num);
        setList(slicedArray);
      } else {
        setList(popular);
      }
    }
  }, [num]);

  return (
    <section className={styles.container}>
      <div className={styles.subContainer}>
        <h1>Popular Collections</h1>

        <div className={styles.cardsContainer}>
          <Slider {...settings}>
            {popular.map((i) => (
              <PopularCollection
                key={i.id}
                name={i.name}
                creator={i.creator}
                collectionImage={i.collectionImg}
                images={i.images}
                total={i.total}
              />
            ))}
          </Slider>
        </div>

        {/* mobile */}
        <div className={styles.cardsContainerMobile}>
          {list &&
            list.map((i) => (
              <PopularCollection
                key={i.id}
                name={i.name}
                creator={i.creator}
                collectionImage={i.collectionImg}
                images={i.images}
                total={i.total}
              />
            ))}
        </div>

        {/* load more button for mobile devices */}
        <button
          className={styles.loadMore}
          onClick={() => setNum((num) => num + 2)}
        >
          Load More
        </button>
      </div>
    </section>
  );
};

export default Popular;
